/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventActionModel } from './EventActionModel';
import {
    EventActionModelFromJSON,
    EventActionModelFromJSONTyped,
    EventActionModelToJSON,
} from './EventActionModel';

/**
 * 
 * @export
 * @interface FormButtonEventModel
 */
export interface FormButtonEventModel {
    /**
     * 
     * @type {EventActionModel}
     * @memberof FormButtonEventModel
     */
    click?: EventActionModel;
}

/**
 * Check if a given object implements the FormButtonEventModel interface.
 */
export function instanceOfFormButtonEventModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormButtonEventModelFromJSON(json: any): FormButtonEventModel {
    return FormButtonEventModelFromJSONTyped(json, false);
}

export function FormButtonEventModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormButtonEventModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'click': !exists(json, 'click') ? undefined : EventActionModelFromJSON(json['click']),
    };
}

export function FormButtonEventModelToJSON(value?: FormButtonEventModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'click': EventActionModelToJSON(value.click),
    };
}

